var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgI = function SvgI(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 4,
    fill: "#EEEDFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4886 10.5V5.95455H7.49428V10.5H6.4886ZM6.99997 4.86364C6.80394 4.86364 6.63491 4.79688 6.49286 4.66335C6.35366 4.52983 6.28406 4.36932 6.28406 4.18182C6.28406 3.99432 6.35366 3.83381 6.49286 3.70028C6.63491 3.56676 6.80394 3.5 6.99997 3.5C7.19599 3.5 7.3636 3.56676 7.50281 3.70028C7.64485 3.83381 7.71588 3.99432 7.71588 4.18182C7.71588 4.36932 7.64485 4.52983 7.50281 4.66335C7.3636 4.79688 7.19599 4.86364 6.99997 4.86364Z",
    fill: "#5547DD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgI);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "i.5ad452d64c7ec13fe0398a92daa1be0f.svg";